// fetchCountries.js
import { message } from "antd";
import { selectBaseUrl, selectProdTestUrl } from "../../redux/slices/envSlice";
// import { useSelector } from "react-redux";

export const fetchStates = async (setStates, baseUrl, prodTestUrl) => {
  // const baseUrl = useSelector(selectBaseUrl);
  // const prodTestUrl = useSelector(selectProdTestUrl);
  try {
    const response = await fetch(
      `${prodTestUrl ? prodTestUrl : baseUrl}/api/admin-get-all-state/`
    );
    if (response.ok) {
      const data = await response.json();
      setStates(data);
    } else {
      message.error("Failed to fetch states.");
    }
  } catch (error) {
    message.error("An error occurred while fetching states.");
  }
};